import HourlyAbsenceForm from './HourlyAbsenceForm';

import { AbsenceFormProps } from './AbsenceFormProps';
import { useExtraFieldsFormValidationByFormId7 } from '../ExtraFields/useExtraFieldsFormValidation7';
import { ExtraFieldsSupportedObject } from '../ExtraFields';
import { extraFieldsContextParams } from '../ExtraFields';
import { FieldType } from 'server/src/apps/internal-shared/repositoriesShared/EmployeeDataRepositoryBase';
import { useMemo } from 'react';
import Loading from './Loading';
import React from 'react';
import { ExtraFieldsFormId } from '../ExtraFields/types';
import { createHourlyAbsenceValidationSchema } from './validationSchema';

export const HourlyAbsenceFormWithExtraFields: React.FC<
  React.PropsWithChildren<AbsenceFormProps>
> = (props) => {
  const { applyExtraFieldsValidationSchema, loading } =
    useExtraFieldsFormValidationByFormId7({
      objectApiName: ExtraFieldsSupportedObject.Absence,
      formId: ExtraFieldsFormId.AbsencesRequestAbsence,
      contextParams: [
        {
          name: extraFieldsContextParams.absenceRequestForm.absenceCategoryName,
          type: FieldType.String,
          value: props.categoryName,
        },
      ],
    });

  // it is super important to never change validationSchemaWithExtraFields property, otherwise validation is broken
  const validationSchemaWithExtraFields = useMemo(
    () =>
      applyExtraFieldsValidationSchema(createHourlyAbsenceValidationSchema()),
    [applyExtraFieldsValidationSchema],
  );

  if (loading) {
    return (
      <Loading
        absenceCategoriesGroupSelect={props.absenceCategoriesGroupSelect}
        absenceCategorySelect={props.absenceCategorySelect}
      />
    );
  }

  return (
    <HourlyAbsenceForm
      {...props}
      validationSchema={validationSchemaWithExtraFields}
    />
  );
};
